// Provisional (Phase 1) copy. Final language arrives in Phase 3.

export const HUMAN_STRUCTURE = {
  lead: "Human Structure is the shared intellectual foundation of Ordo Intelligence. It concerns how people, responsibilities, technology, knowledge, authority, and intelligence are arranged around human purposes, and how those arrangements can be understood and improved.",
  body: "Both operations draw on it. Diagnostics & Software uses it to understand a customer's actual situation. Research & Products uses it to understand a human activity before deciding what technology that activity calls for.",
  elements: ["People", "Responsibilities", "Technology", "Knowledge", "Authority", "Intelligence"],
};

export const FORMATION = [
  {
    id: "research", index: "R1", label: "Research",
    happens: "Independent research into a human activity: what people are trying to do and what structure the activity requires.",
    from: "A human activity and its needs, not a technology looking for a use.",
    leaves: "An understanding of the activity's structure.",
  },
  {
    id: "formation", index: "R2", label: "Formation",
    happens: "The appropriate technological responsibility is formed around the activity, drawing on Human Structure and General Ordo.",
    from: "Research findings and the shared methods.",
    leaves: "A defined responsibility and the mechanisms it requires.",
  },
  {
    id: "prototype", index: "R3", label: "Prototype",
    happens: "Mechanisms are built and tested against the activity they are meant to serve.",
    from: "A defined responsibility.",
    leaves: "Prototypes, and what they reveal about the activity.",
  },
  {
    id: "product", index: "R4", label: "Product",
    happens: "A product takes the form its human setting calls for.",
    from: "What prototyping has shown.",
    leaves: "A distinct product experience.",
  },
  {
    id: "learning", index: "R5", label: "Learning",
    happens: "What the product teaches returns to research and to the shared foundation.",
    from: "The product in its human setting.",
    leaves: "Revised understanding: the start of the next cycle.",
  },
];

export const PHYSICAL_BREAKPOINT = {
  title: "Physical Breakpoint",
  text: "A supporting example of product formation: how a software mechanism can become a tangible product experience.",
  note: "Shown here as part of Research & Products. No standalone commercial page at this stage.",
};
